import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, Scroll } from '@angular/router';
import { Claimants } from '../../models/claimant';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CommonModule, ViewportScroller } from '@angular/common';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { filter } from 'rxjs';
import { RouterLink } from '@angular/router';
import { NavMenu } from '../nav-menu/nav-menu';
import { Authenticate } from '../../models/authenticate';
import { Utm } from "../../models/utm";


type StateItem = { Id: string; Name: string };

@Component({
  selector: 'app-file-not-noticed',
  imports: [CommonModule, ReactiveFormsModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, BsDatepickerModule, RouterLink, NavMenu],
  providers: [provideNgxMask()], // Provide at the component level
  templateUrl: './file-not-noticed.html',
  styleUrl: './file-not-noticed.css',
})

//@Injectable({
//  providedIn: 'root' // Add this line for LocalStorageService
//})

export class FileNotNoticed implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  lossDatePickerConfig: Partial<BsDatepickerConfig>;

  submitted = false;
  clicked = false;
  clickedOnce = false;
  /*isChecked = false;*/

  addButtonClicked = false;
  allStates: any = [];
  allCountries: any = [];
  allHours: any = [];
  allDocumentationTypes: any = [];
  claimantsInformation: FormGroup;
  oopeList: any = [];
  submittedClaim: Claimants;
  showDivForUS: boolean = false;
  showDivForNonUS: boolean = false;
  showDivCaliforniaResident: boolean = false;
  showDivUploadDocumentMessage: boolean = false;
  showDivIllinoisInformation: boolean = false;
  response: string | undefined;
  errorMessage: string = "";
  minDate: Date;
  supportingDocuments: File[] = [];
  calculatedValue: any;
  dateLoaded: Date;
  claimStartTime: Date;
  claimEndTime: Date;
  authenticatedUser!: Authenticate;
  utmtags!: Utm;


  validation_FormErrorMessages = {
    phone1: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 10 digits" },
      { type: "maxlength", message: "This field must not be at greater 10 digits" },
      { type: "pattern", message: "Only use numbers" }
    ],
    firstName: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 digits" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    lastName: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    street1: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    city: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 40 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    state: [
      { type: "required", message: "This field is required" },
    ],
    street2: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    city2: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 40 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    state2: [
      { type: "required", message: "This field is required" },
    ],
    signature: [
      { type: "required", message: "This field is required" },
      { type: "minlength", message: "This field must be at least 2 characters" },
      { type: "maxlength", message: "This field must not be at greater 50 digits" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    emailAddress: [
      { type: "required", message: "This field is required" },
      { type: "maxlength", message: "This field must not be at greater 255 characters" },
      { type: "pattern", message: "This is not a valid email address" }
    ],
    zip: [
      { type: "required", message: "This field is required" },
      { type: "pattern", message: "US zip Code with format 99999 or 99999-9999 alone are accepted" }
    ],
    pin: [
      { type: "pattern", message: "This field accepts only numerical digits 0-9 and characters A-Z" },
      { type: "minlength", message: "This field must be at least 6 characters" },
      { type: "maxlength", message: "This field must not be at greater 6 digits/characters" },
    ],
    uniqueId: [
      { type: "pattern", message: "This field accepts only numerical digits 0-9 and characters A-Z" },
      { type: "minlength", message: "This field must be at least 8 digits/characters" },
      { type: "maxlength", message: "This field must not be at greater 8 digits/characters" },
    ],
    zip2: [
      { type: "required", message: "This field is required" },
      { type: "pattern", message: "US zip Code with format 99999 or 99999-9999 alone are accepted" }
    ],
    californiaResidentDuringPeriod: [
      { type: "required", message: "This field is required" }
      //{ type: "pattern", message: "US zip Code with format 99999 or 99999-9999 alone are accepted" }
    ],
    acknowledgement: [
      { type: "required", message: "This field is required" }
      //{ type: "pattern", message: "US zip Code with format 99999 or 99999-9999 alone are accepted" }
    ],
    googleRecaptchaToken: [
      { type: "required", message: "This field is required" }
      //{ type: "pattern", message: "US zip Code with format 99999 or 99999-9999 alone are accepted" }
    ],
  };


  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private claimantService: ClaimantService,
    private viewportScroller: ViewportScroller) { }

  ngOnInit() {
    /*this.storage.clear();*/
    this.authenticatedUser = this.storage.retrieve('authenticatedUser');
    this.utmtags = this.storage.retrieve('utmTags');
    this.viewportScroller.scrollToPosition([0, 0]);
    //this.router.events.pipe(
    //  filter((e: any): e is Scroll => e instanceof Scroll)
    //).subscribe(e => {
    //  if (e.position) {
    //    this.viewportScroller.scrollToPosition(e.position);
    //  } else if (e.anchor) {
    //    this.viewportScroller.scrollToAnchor(e.anchor);
    //  } else {
    //    this.viewportScroller.scrollToPosition([0, 0]);
    //  }
    //});

    this.lossDatePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        maxDate: new Date(2026, 3, 21),
        minDate: new Date(2018, 2, 13),
        dateInputFormat: 'MM/DD/YYYY',
      });
    this.claimStartTime = new Date();
    this.loadAllStates();
    this.claimantsInformation = this.fb.group({
      firstName: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      lastName: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      street2: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city2: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state2: ['', Validators.compose([Validators.required])],
      zip2: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      phone1: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      uniqueId: ["", Validators.compose([Validators.maxLength(8), Validators.minLength(8), Validators.pattern("^[a-zA-Z0-9]+$")])],
      pin: ["", Validators.compose([Validators.maxLength(6), Validators.minLength(6), Validators.pattern("^[a-zA-Z0-9]+$")])],
      californiaResidentDuringPeriod: ['', Validators.compose([Validators.required])],
      acknowledgement: [false, Validators.compose([Validators.requiredTrue])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
    });
  }

  loadAllStates() {
    this.httpClient.get("/assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }
  get f() { return this.claimantsInformation.controls; }


  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }



  getCaliforniaResidentValue($event) {
    /*this.changed = true;*/
    // if you need the event source and value it can be accessed.
    /*console.log($event.target.value);*/
    if ($event.target.value === 'No') {
      this.showDivCaliforniaResident = false;
    }
    else {
      this.showDivCaliforniaResident = true
    }
  }

  onSubmit() {
    this.submitted = true;
    this.claimEndTime = new Date();

    // stop here if form is invalid
    if (this.claimantsInformation.invalid) {
      return;
    }

    this.clicked = true;
    const claimant = this.claimantsInformation.value;
   
    if (this.authenticatedUser !== null) {
      claimant.utm_source = this.utmtags?.utm_source ?? null;
      claimant.utm_medium = this.utmtags?.utm_medium ?? null;
      claimant.utm_campaign = this.utmtags?.utm_campaign ?? null;
      claimant.utm_content = this.utmtags?.utm_content ?? null;
      claimant.uniqueId = this.authenticatedUser.uniqueId;
      claimant.pin = this.authenticatedUser.pin;
      claimant.wasClaimantNoticed = true;
      claimant.noticeId = this.authenticatedUser?.noticeId ?? null;
    }
    if (this.authenticatedUser === null) {
      claimant.wasClaimantNoticed = false;
      claimant.noticeId = null;
    }
   
    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    this.spinner.show();

    /*console.log(claimant);*/
    this.CreateClaimant(claimant);
  }

  CreateClaimant(claimant: Claimants) {
    this.claimantService.createClaimant(claimant).subscribe(res => {
      this.submittedClaim = res;
      if (this.submittedClaim.claimNumber === null || this.submittedClaim.googleRecaptchaToken === null || this.submittedClaim.googleRecaptchaSuccess === 'false') {
        this.spinner.hide();
        this.errorMessage = 'We apologize for the inconvenience. Due to an issue processing your online submission, please use the link below to complete and submit a paper Claim Form via email.';
        return;
      }
      this.storage.store('claimant', this.submittedClaim);


      //localStorage.removeItem('authenticatedUser');
      //4
      //localStorage.removeItem('utmTags');


      this.storage.clear('authenticatedUser');
      this.storage.clear('utmTags');

      this.authenticatedUser = null;
      this.utmtags = null;

      this.submitted = false;
      this.claimantsInformation.reset();

      this.spinner.hide();
      this.router.navigate(['/complete']);
      
      //this.storage.store('claimant', this.submittedClaim);
      //this.submitted = false;
      //this.storage.clear('utmTags'); // Clear UTM tags after submission
      //this.authenticatedUser = null; // Clear authenticated user after submission 
      //this.claimantsInformation.reset();
      //this.spinner.hide();
      //this.router.navigate(['/complete']);

    });
  }
}






//  CreateClaimant(claimant: Claimants) {
//    this.claimantService.createClaimant(claimant).subscribe({
//      next: (res) => {
//        this.submittedClaim = res;
//        if (this.submittedClaim.googleRecaptchaToken === null || this.submittedClaim.googleRecaptchaSuccess === 'false') {
//          this.spinner.hide();
//          this.errorMessage = 'We apologize for the inconvenience. Due to an issue processing your online submission, please use the link below to complete and submit a paper Claim Form via email.';
//          return
//        }
//        this.storage.store('claimant', this.submittedClaim);
//        this.submitted = false;
//        this.claimantsInformation.reset();
//        this.spinner.hide();
//        this.errorMessage = '';
//        this.router.navigate(['/complete']);
//      },
//      //error: (err) => {

//      //  this.spinner.hide();

//      //  this.errorMessage = '';

//      //  if (err.status === 400) {
//      //    this.errorMessage = 'We apologize for the inconvenience. Due to an issue processing your online submission, please use the link below to complete and submit a paper Claim Form via email.';
//      //  }
//      //  //else if (err.status === 500) {
//      //  //  this.errorMessage = 'An internal server error occurred. Please try again later.';
//      //  //}
//      //  //else {
//      //  //  this.errorMessage = 'An unexpected error occurred.';
//      //  //}
//      //}
//    });
//  }
//}



//CreateClaimant(claimant: Claimants) {

//  this.claimantService.createClaimant(claimant).subscribe({
//    next: (res) => {
//      this.submittedClaim = res;
//      this.storage.store('claimant', this.submittedClaim);
//      this.submitted = false;
//      this.claimantsInformation.reset();
//      this.spinner.hide();
//      this.router.navigate(['/complete']);
//    },
//    error: (err) => {

//      this.spinner.hide();

//      console.error('CreateClaimant Error:', err);

//      this.errorMessage = 'An unexpected error has occurred. You will need to download a copy of the claim form, fill it out and submit via email.';

//      if (err.error?.message) {
//        this.errorMessage = err.error.message;
//      }

//      if (err.error?.errorCodes) {
//        this.errorMessage += ` (${err.error.errorCodes})`;
//      }

//      // Display the error message
//      /*alert(errorMessage);*/

//      // If using a toast service:
//      // this.messageService.add({
//      //   severity: 'error',
//      //   summary: 'Submission Failed',
//      //   detail: errorMessage
//      // });
//    }
//  });
//}

//CreateClaimant(claimant: Claimants) {
//  this.claimantService.createClaimant(claimant).subscribe(res => {
//    this.submittedClaim = res;
//    this.storage.store('claimant', this.submittedClaim);
//    this.submitted = false;
//    this.claimantsInformation.reset();
//    this.spinner.hide();
//    this.router.navigate(['/complete']);
//  });
//}
